import { render, staticRenderFns } from "./ModalPreviewSubunidad.vue?vue&type=template&id=ff258c70"
import script from "./ModalPreviewSubunidad.vue?vue&type=script&lang=js"
export * from "./ModalPreviewSubunidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff258c70')) {
      api.createRecord('ff258c70', component.options)
    } else {
      api.reload('ff258c70', component.options)
    }
    module.hot.accept("./ModalPreviewSubunidad.vue?vue&type=template&id=ff258c70", function () {
      api.rerender('ff258c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/unidad-compuesta/ModalPreviewSubunidad.vue"
export default component.exports